/* eslint-disable @typescript-eslint/no-empty-function */

import Haptics from 'expo-haptics';

export { ImpactFeedbackStyle, NotificationFeedbackType } from 'expo-haptics';

export const notificationAsync: (typeof Haptics)['notificationAsync'] =
  async () => {};
